import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Bewbs",
  "description": "",
  "published": "2008-05-21T00:00:00.000Z",
  "redirect_from": ["/blog/bewbs/swizec/110"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`That's right, swizec is writing yet another blog about boobs. I seem to write a lot of these, at least one a year and if I was less of a lazy bastard I'd actually take this opportunity to link to the lot, but I `}<em parentName="p">{`am`}</em>{` a lazy bastard and won't do it. But let's explore the range of my vocabulary and attempt to use every term for breasts only once.`}</p>
    <p>{`So let's begin ... what was I thinking about the other day ... something about chest ... Ah that's right. My mind was contemplating the interesting fact about which gender gives more importance to these lumps of flesh bestowed upon women and the more I thought about it the more it was painfully obvious that it's women.`}</p>
    <p>{`Don't get me wrong, it's not that men don't love a good pair of jugs, it's just that for us they're more of an appendage, an added bonus if you will, to the whole package. They're a fun toy and a soothing place to rest one's eyes upon, also very awesome for use as pillows, forearm exercise devices, physics studying apparatus, but that's all they are. We like the woman for the woman not for her knockers.`}</p>
    <p>{`Women on the other hand, seem to base a lot of their self-worth on the shape, size, firmness, perkiness and whathaveyou of their baby-feeders. They also judge other women based on it and, if I'm not mistaken, hold long discussions over them. It's weird. There's even women out there who get their blubber bags enlarged simply because they think men will like them more if they do. You're wrong, we won't, but you might.`}</p>
    <p>{`So in conclusion, to men, it's the whole package that matters and titties are just a part of it, whereas to women it's, apparently, the tits that matter.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      